import { productList } from "./product-list";
import { productForm } from "./product-form";
import { importProductsXlsx } from "./import-products-xlsx";
import productsTab from "./products-tab.json";

export const products = {
	barMultiSelect: {
		stock: "Stock",
		printerIp: "IP Imprimante",
		addAll: "Ajouter tous",
		removeAll: "Supprimer tous",
	},
	productList,
	productForm,
	importProductsXlsx,
	productsTab,
};
